import {
   EntitlementStatementLegalBasisQuery,
   Guardian,
   GuardianQuery,
   LegalBasis,
} from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { PatientLoader } from '../../../common/PatientLoader';
import { entitlementStatementsTranslationKeys } from '../../../translations';

type RepresentativeEntitlementStatementCreateFormLoaderRenderProps = {
   guardians: Guardian[];
   legalBasis: LegalBasis[];
};

type RepresentativeEntitlementStatementCreateFormLoaderProps = {
   readonly patientId: number;
   readonly children: (renderProps: RepresentativeEntitlementStatementCreateFormLoaderRenderProps) => JSX.Element;
};

export const RepresentativeEntitlementStatementCreateFormLoader = ({
   patientId,
   children,
}: RepresentativeEntitlementStatementCreateFormLoaderProps): JSX.Element => {
   const { data: guardians, loading: guardiansLoading, error: guardiansError } = useCqrsSearch<Guardian>(() => {
      const query = new GuardianQuery();
      query.patientId = Slot.of(Number(patientId));
      return query;
   });
   const { data: legalBasis, loading: legalBasisLoading, error: legalBasisError } = useCqrsSearch<LegalBasis>(() => {
      const query = new EntitlementStatementLegalBasisQuery();
      query.entitlementStatementType = 'FOR_REPRESENTATIVE';
      return query;
   });

   if (guardiansLoading || legalBasisLoading) {
      return <PatientLoader />;
   }

   if (guardiansError || legalBasisError) {
      return (
         <Message
            testId={'representativeEntitlementStatementLoaderError'}
            type={MessageType.NEGATIVE}
            label={entitlementStatementsTranslationKeys.createModal.errors.loadData}
            displayIndicator
         />
      );
   }

   return children({
      guardians: guardians,
      legalBasis: legalBasis,
   });
};
